import { Dialog } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AiTermsOfUseComponent } from '../../../pages/aida/pages/ai-terms-of-use/ai-terms-of-use.component';
import { inputSubtext } from '../chat-container/constants';

@Component({
    selector: 'mapp-legal-disclaimer',
    templateUrl: './legal-disclaimer.component.html',
    styleUrl: './legal-disclaimer.component.scss',
    standalone: true,
    imports: [CommonModule],
})
export class LegalDisclaimerComponent {
    readonly DEFAULT_LEGAL_DISCLAIMER = inputSubtext;

    @Input() disclaimerContainerClass = '';
    @Input() imageUrl;

    /**
     *
     * @param _dialog
     */
    constructor(private readonly _dialog: Dialog) {}

    /**
     *
     * @param event
     */
    openTermsOfUsePopUp(event: Event): void {
        event.preventDefault();

        this._dialog.open(AiTermsOfUseComponent, {
            hasBackdrop: true,
            autoFocus: false,
            disableClose: false,
            width: '640px',
            id: 'tips',
            minHeight: '29rem',
        });
    }
}
